import { render, staticRenderFns } from "./GlobalFilterCntrl.vue?vue&type=template&id=65d6c66d&scoped=true"
import script from "./GlobalFilterCntrl.vue?vue&type=script&lang=js"
export * from "./GlobalFilterCntrl.vue?vue&type=script&lang=js"
import style0 from "./GlobalFilterCntrl.vue?vue&type=style&index=0&id=65d6c66d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d6c66d",
  null
  
)

export default component.exports